/**
 * Watch Handover Checklist
 * At each change of watch
 * Regulatory: STCW
 */

export const WATCH_HANDOVER_CHECKLIST = {
  id: 'watch_handover',
  name: 'Watch Handover',
  description: 'At each change of watch',
  icon: 'RefreshCw',
  regulatory: 'STCW',
  isCustomisable: true,
  items: [
    { id: 'wh_1', text: 'Position confirmed', required: true },
    { id: 'wh_2', text: 'Course and speed confirmed', required: true },
    { id: 'wh_3', text: 'Traffic situation reviewed', required: true },
    { id: 'wh_4', text: 'Weather and conditions reviewed', required: true },
    { id: 'wh_5', text: 'Standing orders acknowledged', required: false },
    { id: 'wh_6', text: 'Equipment status confirmed', required: false }
  ]
};
